import React from 'react'
import ReactDOM from 'react-dom'
import './styles.css'
import TreadleReducer from './scenes/reducer/index'

// ========================================

// dev environment
// ReactDOM.render(
//     <TreadleReducer baseLambdaUri='https://uapu3ncx1l.execute-api.us-east-1.amazonaws.com/dev/treadles/reduce' baseS3Uri='https://s3.amazonaws.com/hwtreadlereducer' apiKey='ShWzETKuU2sfvR3P7qiE1tqNyPyOGZU7wwO2qGf0' />,
//     document.getElementById('treadle-reducer-root')
// )


// prod environment

ReactDOM.render(
    <TreadleReducer baseLambdaUri = 'https://m6n0wmlkee.execute-api.us-east-1.amazonaws.com/prod/treadles/reduce'  baseS3Uri = 'https://s3.amazonaws.com/hwtreadlereducer' apiKey = 'nksJFjO6483jzg2eoHJVj4zfE9HR1M17x9vukWFe' />,
    document.getElementById('treadle-reducer-root')
)




// WEBPACK FOOTER //
// ./src/index.js